import { RESET_STATE } from '../../../wizard/store/wizard.action-types';
import { BIRTHDATE_SAVE } from './birthdate.action-types';

const INITIAL_STATE = {
  selected: null,
};

const birthdateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...state,
        selected: null,
      };
    case BIRTHDATE_SAVE:
      return { ...state, selected: action.payload };
    default:
      return state;
  }
};

export default birthdateReducer;
